import { MaterialReactTable } from "material-react-table";
import { Button, Card, CardBody, Row, Col } from "reactstrap";
import { CustomerListRowOptions } from "./CustomerListRowOptions";
import { CustomerPreview } from "./CustomerPreview";
import Simulate from "./Simulate";
import React, { useEffect, useState } from "react";
import CommonModal from "../Utils/CommonModal";
import { deletecustomer } from "../../slices/customer/deletecustomer/thunk";
import { MenuItem } from "@mui/material";
import { navigateToSubscribe } from "./constants/DocumentTableFunctions";
import { fetchDetailedBalance } from "../../slices/customer/detailedBalance/thunk";
import { navigateToCreateCustomer } from "./constants/ListingCustomerFunctions";
import { PasswordModal } from "./PasswordModal";
import { resetUpdatePasswordState } from "../../slices/customer/passwordUpdate/reducer";
import { useSelector } from "react-redux";
import { TelcoHeaderForCustomer } from "./TelcoHeaderForCustomer";
import { hasPermission } from "../Utils/UtilityFunctions";

export const TableForTelco = ({
  getTable,
  searchColumns,
  searchData,
  orderPermission,
  customerPermission,
  navigate,
  dispatch,
  setRenderSimulate,
  setLoading,
  simulateOrPreview,
  index,
  setIndex,
  setActiveTab,
  fetchCustomerDetails,
  stationPermission,
  reservationPermission,
  getCustomerData,
  storeRow,
  setDefault,
  renderSimulate,
  pagination,
  customerData,
  activeTab,
  tabChange,
  setOpen,
  toggle,
  noCurrencyArray,
  currencyArray,
  fetchCustomerSummaryData,
  reservationDataArray,
  duration,
  subscriptionsArray,
  convertNumberOfDaysToMonthYear,
  formatDate,
  getDayDiff,
  current,
  errorMessage,
  errorIcon,
  setGetTable,
  toggleModal,
  setMessageForPopUp,
  setCustomerId,
  messageForPopUp,
  modal,
  customerId,
  TotalCustomers,
  searchExpanding,
  setSearchExpanding,
  viewColumns,
  toggleSettingsModal,
  setErrors,
  integerAndTextAttributes,
  setErrorMessage,
  setErrorIcon,
  searchFields,
  setSearchFields,
  searchCustomerData,
  handleExportData,
  // exportData,
}) => {
  const [modalForSimulate, setModalForSimulate] = useState(false);
  const [passwordModal, setPasswordModal] = useState(false);
  const [passwordCustomer, setPasswordCustomer] = useState(null);
  const [modalType, setModalType] = useState("delete"); // Add this state to track modal type
  const isView = location.pathname.includes("view-customer");

  const [dontShowCloseButton, setDontShowCloseButton] = useState(false);

  function transformData(response) {
    return response?.Customers?.map((customer) => ({
      CustomerId: customer.CustomerId,
      Name: customer.Name,
      Email: customer.Email,
      Mobile: customer.Mobile,
      Address: customer.Address,
      Status: customer?.Status || "",
      msisdn:
        customer.AttributeList?.find(
          (attr) => attr.Name?.toLowerCase() === "msisdn"
        )?.Value || "",
      imsi:
        customer.AttributeList?.find(
          (attr) => attr.Name?.toLowerCase() === "imsi"
        )?.Value || "",
      SiteType:
        customer.AttributeList?.find(
          (attr) => attr?.Name?.toLowerCase() === "site type"
        )?.Value || "",
      PowerSavingMode:
        customer.AttributeList?.find(
          (attr) => attr?.Name?.toLowerCase() === "power saving mode"
        )?.Value || "",
      Tags: customer.Tags || [],
    }));
  }

  const operatorConfiguration = useSelector(
    (state) =>
      state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration
  );
  const rawPermissions = useSelector(
    (state) => state.permissions.permissionsMap
  );

  const permissionsMap = new Map(
    rawPermissions.map(([key, value]) => [key, new Set(value)])
  );

  const subscriptionPermission = hasPermission(permissionsMap, "customer", "subscription")
  const viewPermission = hasPermission(permissionsMap, "miscellaneous", "view")
  const selfcarePermission = operatorConfiguration?.configurations?.selfcare?.value?.SelfcareEnabled?.value === true;
  const operatorId = localStorage.getItem("operatorId");

  const isEIPEnabled = operatorConfiguration?.configurations?.EIP?.value?.Enabled?.value === true;

  const buttonLabel = isEIPEnabled ? "Add Device" : "Add Customer";
  const buttonLabel1 = isEIPEnabled
    ? "Recent updated devices."
    : "Recent updated customers.";

  useEffect(() => {
    dispatch(resetUpdatePasswordState());
  }, [passwordModal, dispatch]);

  const transformedData = transformData(TotalCustomers);

  // Helper function to get modal header based on modal type
  const getModalHeader = () => {
    switch (modalType) {
      case "simulate":
        return "Subscription Required";
      case "delete":
        return `Delete ${isEIPEnabled ? "Device" : "Customer"}`;
      default:
        return `Delete ${isEIPEnabled ? "Device" : "Customer"}`;
    }
  };

  return (
    <>
      <>
        {!getTable && searchExpanding ? (
          <div className="border rounded static-height d-flex align-items-center justify-content-center">
            <div className="flex-column" style={{ textAlign: "center" }}>
              <i className={`${errorIcon} icon-size flex-column`} />
              <p className="text-color-telco ">{errorMessage}</p>
            </div>
          </div>
        ) : (
          <div className="container-fluid px-0">
            <div className="disable-margin-card table-responsive table-customer border me-0 w-100">
              <MaterialReactTable
                data={!getTable ? transformedData || [] : searchData || []}
                columns={searchColumns.filter((column) =>
                  viewColumns?.includes(column.accessorKey || column.header)
                )}
                icons={{
                  DragHandleIcon: () => null,
                }}
                renderTopToolbarCustomActions={({ }) => (
                  <div className="d-flex flex-column flex-lg-row flex-wrap w-100 justify-content-between align-items-center ps-2 py-2 gap-2">
                    <div className="d-flex flex-row gap-2">
                      <TelcoHeaderForCustomer
                        custId={customerId}
                        dispatch={dispatch}
                        setLoading={setLoading}
                        setGetTable={setGetTable}
                        customerPermission={customerPermission}
                        setErrors={setErrors}
                        setErrorMessage={setErrorMessage}
                        setErrorIcon={setErrorIcon}
                        integerAndTextAttributes={integerAndTextAttributes}
                        searchFields={searchFields}
                        setSearchFields={setSearchFields}
                        setRenderSimulate={setRenderSimulate}
                        stationPermission={stationPermission}
                        reservationPermission={reservationPermission}
                        searchCustomerData={searchCustomerData}
                        setCustId={setCustomerId}
                        setSearchExpanding={setSearchExpanding}
                      />
                    </div>

                    <div className="d-flex flex-row gap-2">
                      {/* {customerPermission && customerPermission?.has("export") &&
                        <Button
                          color="secondary"
                          className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                          onClick={() => handleExportData(exportData)}
                        >
                          <i className="ri-download-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                          <span className="px-2 ps-3 ms-2 me-1">Export</span>
                        </Button>} */}

                      {customerPermission?.has(
                        "create"
                      ) && (
                          <Button
                            color="secondary"
                            className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                            onClick={() => navigateToCreateCustomer(navigate)}
                          >
                            <i className="ri-add-fill label-icon align-middle fs-16 me-1"></i>
                            <span className="ps-2 ms-2 me-1">{buttonLabel}</span>
                          </Button>
                        )}
                      {viewPermission && viewPermission?.has("view") &&
                        <div
                          color="secondary"
                          onClick={toggleSettingsModal}
                        >
                          <i className="ri-settings-2-line fs-4 pt-0"></i>
                        </div>}
                    </div>
                  </div>
                )}
                defaultColumn={{
                  minSize: 10,
                  maxSize: 9001,
                  size: 260,
                  muiTableBodyCellProps: {
                    sx: {
                      fontFamily: "Inter,sans-serif",
                    },
                  },
                  muiTableHeadCellProps: {
                    sx: {
                      fontFamily: "Inter,sans-serif",
                      color: "#343A40",
                      borderTop: "1px solid rgba(224, 224, 224, 1)",
                    },
                  },
                }}
                initialState={{
                  columnVisibility: {
                    "mrt-row-expand": false,
                    Email: isEIPEnabled ? false : true,
                  },
                }}
                muiTablePaperProps={{
                  elevation: 0,
                }}
                layoutMode="grid"
                muiTableDetailPanelProps={{
                  sx: {
                    fontFamily: "Inter,sans-serif",
                  },
                }}
                enablePagination={false}
                enableGlobalFilter={false}
                enableColumnOrdering={false}
                enableColumnDragging={false}
                enableDensityToggle={false}
                enableColumnVisibility={false}
                enableFullScreenToggle={false}
                enableHiding={false}
                enableColumnFilters={false}
                enableColumnActions={false}
                displayColumnDefOptions={{
                  "mrt-row-actions": {
                    header: "",
                    enableHiding: false,
                  },
                }}
                enableRowActions={true}
                renderRowActionMenuItems={({ closeMenu, row }) => [
                  customerPermission &&
                    customerPermission?.has("view") ? (
                    <MenuItem
                      className="row-options pb-3"
                      key="view"
                      onClick={() => {
                        simulateOrPreview = "View";
                        navigate(`/view-customer/${row.original.CustomerId}`);
                      }}
                    >
                      <i className="ri  ri-eye-line me-3" />{" "}
                      <span className="me-4">View</span>
                    </MenuItem>
                  ) : null,
                  customerPermission &&
                    customerPermission?.has("update") ? (
                    <MenuItem
                      className="row-options pb-3"
                      key="edit"
                      onClick={() => {
                        navigate(`/update-customer/${row.original.CustomerId}`);
                      }}
                    >
                      <i className="ri-edit-box-line me-3" /> Edit
                    </MenuItem>
                  ) : null,
                  <MenuItem
                    className="row-options pb-3"
                    key="simulate"
                    onClick={(e) => {
                      closeMenu();
                      // Set modal type to simulate BEFORE calling fetchDetailedBalance
                      setModalType("simulate");
                      dispatch(
                        fetchDetailedBalance(
                          row,
                          setLoading,
                          true,
                          navigate,
                          setModalForSimulate,
                          isView,
                          toggleModal
                        )
                      );
                      setMessageForPopUp(
                        `Please subscribe to access the simulate feature for the ${isEIPEnabled ? "device" : "customer"}.`
                      );
                      setDontShowCloseButton(true);
                    }}
                  >
                    <i className="ri ri-signal-tower-line me-3" /> Simulate
                  </MenuItem>,
                  (subscriptionPermission && subscriptionPermission?.has("create"))
                    ? (
                      <MenuItem
                        className="row-options pb-3"
                        key="subscribe"
                        onClick={() => {
                          navigateToSubscribe(row, dispatch, navigate);
                        }}
                      >
                        <i className="ri-add-circle-line me-3 "></i> Subscribe
                      </MenuItem>
                    ) : null,
                  selfcarePermission &&
                    customerPermission &&
                    customerPermission?.has("configurepassword") ? (
                    <MenuItem
                      className="row-options pb-3"
                      key="password"
                      onClick={() => {
                        closeMenu();
                        setPasswordCustomer(row?.original);
                        setPasswordModal(!passwordModal);
                      }}
                    >
                      <i class="ri-lock-password-line me-3" />
                      Configure Password
                    </MenuItem>
                  ) : null,
                  customerPermission &&
                    customerPermission?.has("delete") ? (
                    <MenuItem
                      className="row-options pb-3"
                      key="close"
                      onClick={() => {
                        // Set modal type to delete when delete is clicked
                        setModalType("delete");
                        setMessageForPopUp(
                          `Are you sure you want to delete the ${isEIPEnabled ? "Device" : "Customer"
                          } "${row.original.CustomerId}"?`
                        );
                        toggleModal(row, "single");
                        setCustomerId(row.original.CustomerId);
                        setModalForSimulate(false);
                        setDontShowCloseButton(false);
                        closeMenu();
                      }}
                    >
                      <i className="ri ri-delete-bin-5-line me-3" /> Delete
                    </MenuItem>
                  ) : null,
                ]}
                renderDetailPanel={({ row }) => (
                  <>
                    {renderSimulate ? (
                      <Simulate row={row} />
                    ) : (
                      <div className="preview-customer">
                        <CustomerPreview
                          customerData={customerData}
                          row={row}
                          activeTab={activeTab}
                          setActiveTab={setActiveTab}
                          tabChange={tabChange}
                          open={setOpen}
                          setOpen={setOpen}
                          toggle={toggle}
                          customerAttributeData={
                            customerData?.customerInfo?.attributeList
                          }
                          noCurrencyArray={noCurrencyArray}
                          currencyArray={currencyArray}
                          fetchCustomerSummaryData={fetchCustomerSummaryData}
                          reservationDataArray={reservationDataArray}
                          duration={duration}
                          subscriptionsArray={subscriptionsArray}
                          convertNumberOfDaysToMonthYear={
                            convertNumberOfDaysToMonthYear
                          }
                          formatDate={formatDate}
                          getDayDiff={getDayDiff}
                          current={current}
                        />
                      </div>
                    )}
                  </>
                )}
              />
              <div className="recent-customers-color d-flex justify-content-end align-items-center me-2 mb-1 pb-4">
                <i className="ri ri-error-warning-fill me-2 fs-4"></i>
                {buttonLabel1}
              </div>
            </div>
          </div>
        )}
      </>
      <CommonModal
        messageForPopUp={messageForPopUp}
        toggle={() => toggleModal(customerId, "single")}
        open={modal}
        newLineMessage={
          modalForSimulate && ""
        }
        dontShowCloseButton={dontShowCloseButton}
        buttonText={modalForSimulate ? "Okay!" : "Delete"}
        modalAction={() => {
          if (modalForSimulate) {
            toggleModal(customerId, "single");
          } else {
            dispatch(deletecustomer(customerId, setLoading, 1, pagination));
            toggleModal(customerId, "single");
          }
        }}
        modalHeader={getModalHeader()} // Use the helper function here
      />
      {passwordCustomer && (
        <PasswordModal
          passwordModal={passwordModal}
          setPasswordModal={setPasswordModal}
          setLoading={setLoading}
          navigate={navigate}
          passwordCustomer={passwordCustomer}
          setPasswordCustomer={setPasswordCustomer}
        />
      )}
    </>
  );
};